import React, { useState, useEffect } from "react";
import { FaBars, FaChevronDown, FaPhoneAlt, FaTimes } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';
import ReactGA from 'react-ga4';

import "./Navbar.css";


const Navbar = ({ trackButtonClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [scrollingUp, setScrollingUp] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSpatialTechOptions, setShowSpatialTechOptions] = useState(false);
  const [showProductOptions, setShowProductOptions] = useState(false);
  const [showCommunityOptions, setShowCommunityOptions] = useState(false);
  const [showIndustriesOptions, setShowIndustriesOptions] = useState(false);
  const [showServicesOptions, setShowServicesOptions] = useState(false);


  const navigate = useNavigate();
  const location = useLocation(); // Hook to get current path

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);

      if (currentScrollY > prevScrollY && currentScrollY > 100) {
        setScrollingUp(false);
      } else {
        setScrollingUp(true);
      }

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollY]);

  if (trackButtonClick === undefined) {
    trackButtonClick = (category, action, label) => {
      ReactGA.event({
        category,
        action,
        label
      });
    };
  }

  const handleGetDemoClick = () => {
    trackButtonClick('Button', 'Clicked Get Demo', 'Navbar');
    navigate("/contact", { state: { scrollTo: "contact-form" } });
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      const newState = !prev;
      trackButtonClick('Button', newState ? 'Opened Sidebar' : 'Closed Sidebar', 'Sidebar');
      return newState;
    });
  };

  const toggleSpatialTechOptions = () => {
    setShowSpatialTechOptions(prev => !prev);
    trackButtonClick('Dropdown', 'Toggled SpatialTech Options', 'Research & Development');
  };

  const toggleProductOptions = () => {
    setShowProductOptions(prev => !prev);
    trackButtonClick('Dropdown', 'Toggled Product Options', 'Products');
  };

  const toggleCommunityOptions = () => {
    setShowCommunityOptions(prev => !prev);
    trackButtonClick('Dropdown', 'Toggled Community Options', 'Community');
  }

  const toggleIndustriesOptions = () => {
    setShowIndustriesOptions(prev => !prev);
    trackButtonClick('Dropdown', 'Toggled Industries Options', 'Industries');
  };

  const toggleServicesOptions = () => {
    setShowServicesOptions(prev => !prev);
    trackButtonClick('Dropdown', 'Toggled Services Options', 'Services');
  };

  const handleSidebarLinkClick = (label) => {
    setIsSidebarOpen(false);
    trackButtonClick('Link', `Clicked ${label}`, 'Sidebar');
    window.scrollTo({ top: 0, behavior: 'auto' });
  };



  return (
    <>
      <div className={`navbar-container ${isScrolled ? "navbar-shrink" : ""}`}>
        <header className={`navbar ${scrollingUp ? "show-navbar" : "hide-navbar"}`}>
          <div className="navbar-inner">
            <Link
              to="/company"
              className="company-logo"
              onClick={() => {
                setIsSidebarOpen(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              {location.pathname.toLowerCase() === "/products/spatialcatalogue" ? (
                <>
                  <span className="logo-spatial">Spatial</span>
                  <span className="logo-divider">|</span>
                  <span
                    className="logo-catalogue"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsSidebarOpen(false);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Catalogue
                  </span>
                </>
              ) : (
                <>
                  Spatial
                  <span
                    className="company-logo-box"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsSidebarOpen(false);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    CT
                  </span>
                </>
              )}
            </Link>


            <div className="nav-right">
              <div className="phone-icon-wrapper">
                <FaPhoneAlt className="phone-icon" />
                <a href="tel:+919769012101" className="phone-text">+91 97690 12101</a>
              </div>

              <div className="desktop-only nav-actions">
                <ScrollLink to="contact-form" smooth={false} duration={500} offset={-180}>
                  <button className="contact-btn" onClick={handleGetDemoClick}>
                    Get Demo
                  </button>
                </ScrollLink>
              </div>
              <div className="menu-icon-container" onClick={toggleSidebar}>
                {isSidebarOpen ? <FaTimes className="menu-icon" /> : <FaBars className="menu-icon" />}
              </div>
            </div>
          </div>
        </header>
      </div>

      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}>
          <div className="sidebar" onClick={e => e.stopPropagation()}>
            <div className="close-sidebar" onClick={toggleSidebar}>
              <p className="close-icon"> X </p>
            </div>
            <ul className="sidebar-links">
              <li>
                <Link to="/company" className="sidebar-main-link" onClick={() => handleSidebarLinkClick("Company")}>
                  Company
                </Link>
              </li>
              <hr className="straightline" />
              <li>
                <div className="dropdown-toggle" onClick={toggleServicesOptions}>
                  Services
                  <FaChevronDown className={`spatial-chevron ${showServicesOptions ? "rotated-up" : ""}`} />
                </div>
                {showServicesOptions && (
                  <ul className="submenu dropup show">
                    <hr className="straightline" />
                    <li><Link to="/services/industries" onClick={() => handleSidebarLinkClick("Industries")}>For Industries</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/Academia" onClick={() => handleSidebarLinkClick("academia")}>For Academia </Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/xrinfrastructure" onClick={() => handleSidebarLinkClick("XR Infrastructure")}>XR Infrastructure</Link></li>

                    {/* <li><Link to="/services/xrworkshops" onClick={() => handleSidebarLinkClick("XR Awareness Workshops")}>XR Awareness Workshops</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/virtualwalkthrough" onClick={() => handleSidebarLinkClick("VirtualWalkthrough")}>Immersive Walk-throughs & Simulations </Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/training" onClick={() => handleSidebarLinkClick("Hands-On Training")}>Immersive Skill Training</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/collaboration" onClick={() => handleSidebarLinkClick("Real time Collaboration")}>Remote XR Collaboration</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/services/monitoring" onClick={() => handleSidebarLinkClick("Smart Monitoring")}>Spatial Monitoring & Managament Systems</Link></li> */}
                  </ul>
                )}
              </li>
              <hr className="straightline" hr />
              <li>
                <div className="dropdown-toggle" onClick={toggleSpatialTechOptions}>
                  Research & Innovation
                  <FaChevronDown className={`spatial-chevron ${showSpatialTechOptions ? "rotated-up" : ""}`} />
                </div>
                {showSpatialTechOptions && (
                  <ul className="submenu dropup show">
                    <hr className="straightline" />
                    <li><Link to="/ResearchAndInnovation/academiccollaborations" onClick={() => handleSidebarLinkClick("academic collaborations")}>Academic Collaborations</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/ResearchAndInnovation/CorporateR&DPrograms" onClick={() => handleSidebarLinkClick("BlockChain")}>Corporate R&D Programs</Link></li>
                  </ul>
                )}
              </li>
              <hr className="straightline" />

              <li>
                <div className="dropdown-toggle" onClick={toggleCommunityOptions}>
                  School of Spatial Computing
                  <FaChevronDown className={`spatial-chevron ${showCommunityOptions ? "rotated-up" : ""}`} />
                </div>
                {showCommunityOptions && (
                  <ul className="submenu dropup show">
                    <hr className="straightline" />
                    {/* <li><Link to="/school/courses" onClick={() => handleSidebarLinkClick("Courses")}>Courses</Link></li>
                <hr className="straightline" />
                <li><Link to="/school/newsletter" onClick={() => handleSidebarLinkClick("Newsletter")}>Newsletter</Link></li>
                <hr className="straightline" />
                <li><Link to="/school/hackathon" onClick={() => handleSidebarLinkClick("Hackathon")}>Hackathon</Link></li> */}
                    <li><Link to="/school/spatialhub" onClick={() => handleSidebarLinkClick("SpatialHub")}>Spatial Hub</Link></li>
                  </ul>
                )}
              </li>

              <hr className="straightline" />

              <li>
                <div className="dropdown-toggle" onClick={toggleIndustriesOptions}>
                  Sectors
                  <FaChevronDown className={`spatial-chevron ${showIndustriesOptions ? "rotated-up" : ""}`} />
                </div>
                {showIndustriesOptions && (
                  <ul className="submenu dropup show">
                    <hr className="straightline" />
                    <li><Link to="/sectors/aerospaceAndautomobile" onClick={() => handleSidebarLinkClick("Aerospace & Automobile")}>Aerospace & Automobile</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/heavyindustries" onClick={() => handleSidebarLinkClick("Manufacturing & Heavy Industries")}>Manufacturing & Heavy Industries</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/healthcare" onClick={() => handleSidebarLinkClick("Healthcare & Life Sciences")}>Healthcare & Life Sciences</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/education&skilling" onClick={() => handleSidebarLinkClick("Education & Skilling")}>Education & Skilling</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/education" onClick={() => handleSidebarLinkClick("Energy,Utilities & Smart Infrastructure")}>Energy,Utilities & Smart Infrastructure</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/aec" onClick={() => handleSidebarLinkClick("Architecture, Engineering & Construction")}>Architecture, Engineering & Construction</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/learningandinnovation" onClick={() => handleSidebarLinkClick("Corporate Learning & Innovation")}>Corporate Learning & Innovation</Link></li>
                    <hr className="straightline" />
                    <li><Link to="/sectors/hospitalityandtourism" onClick={() => handleSidebarLinkClick("Hospitality & Tourism")}>Hospitality & Tourism</Link></li>
                  </ul>
                )}
              </li>
              <hr className="straightline" />
              <li>
                <div className="dropdown-toggle" onClick={toggleProductOptions}> Products
                  <FaChevronDown className={`spatial-chevron ${showProductOptions ? "rotated-up" : ""}`} />
                </div>
                {showProductOptions && (
                  <ul className="submenu dropup show">
                    <hr className="straightline" />
                    <li><Link to="/products/dhapra" onClick={() => handleSidebarLinkClick("DhaPra")}>DHAPRA-1.0</Link></li>
                    {/* <hr />
                    <li><Link to="/products/spatialviewer" onClick={() => handleSidebarLinkClick("SpatialViewer")}>Spatial Viewer-1.0</Link></li> */}
                    <hr />
                    <li><Link to="/products/spatialcatalogue" onClick={() => handleSidebarLinkClick("SpatialCatalogue")}>Spatial Catalogue</Link></li>
                  </ul>
                )}
              </li>
              <hr className="straightline" />

            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
